var Vendd = (function (Vendd) {
	'use strict';

    var pending = false;
    var pendingSessionStatus = true;
	Vendd.Cart.PendingMessages = null;
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.DownLoadExcel, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.DownLoadExcelSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.DownLoadExcelFailure(response));
		}

		var options = {
			url: 'EcomService.svc/GetCartItemsToExcel',
			data: {
				param: envelope.message.data
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.Cart, function (envelope) {
        pending = false;
        pendingSessionStatus = false;
        if (envelope.message.data.IsNewSession)
            Vendd.Cart.ClearClientModel();

        if (venddProjectConfigs.CartModelEnabled) {
            if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
			} else { 
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
			}
        }

    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetModel, Vendd.Cart, function (envelope) {

		if (pending === true) {
			return false;
		};

        if (pendingSessionStatus) {
            pending = true;
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionState());
            return false;
        }

		function onSuccess(response) {
			model = response.data ? $.extend(true, {}, response.data, { LangCode: LhApp.Context.Language }) : response.data;
			if (venddProjectConfigs.CartAvailabilityRestrictionMessages) {
				try {
					if (Vendd.Cart.PendingMessages) model.Cart.PendingMessages = $.merge([], Vendd.Cart.PendingMessages);
				} catch (ex) {
					model.Cart.PendingMessages = null;
				}
				Vendd.Cart.PendingMessages = null;
			}
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));

            Vendd.Cart.SetClientModel(model);
			pending = false;
		}

		function onFailure(response) {

			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			pending = false;
		}

		var itemId = 0, templateCode = "";
		if (LhApp.Context.Item !== undefined) {
			itemId = LhApp.Context.Item.Id;
		}

		if (LhApp.Context.Item) {
		    templateCode = LhApp.Context.Item.Template;
		}

		var options = {
		    data: { currentItemId: itemId, templateCode: templateCode },
		    url: 'api/Cart/GetCartViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (model != null && model != undefined && Vendd.Cart.GetClientModel() != null && document.cookie.indexOf('ForceClearCartLocalStorage') == -1) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));
			return true;
		}

		pending = true;
        Cookies.remove('ForceClearCartLocalStorage', { path: '/' });

		pending = true;
		Vendd.Service.call(options);

		return true;
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, Vendd.Cart, function (envelope) {
        if (envelope && !envelope.message.data.IsLocalStorageCache)
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UpdateNewLetterVariables(2, null));
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddCompleted(response));
			if (venddProjectConfigs.CartAvailabilityRestrictionMessages) {
				Vendd.Cart.PendingMessages = null;
				try {
					Vendd.Cart.PendingMessages = JSON.parse(response.data).Messages;
				} catch (ex) {
					Vendd.Cart.PendingMessages = null;
				}
			}
			if (response.success && response.code === 'OperationSuccesful') {
				Vendd.Cart.ClearClientModel();

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ProductAdded(envelope.message.data.id));
				
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));

				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else if (response.success && response.code === 'AlreadyInCart') {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AlreadyInCart(envelope.message.data.id));
			} else if (response.success && response.code === 'ValidationError') {
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddCompleted(response));
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

        var options = {
            url: 'EcomService.svc/AddToCart',
            data: {
                item: {
                    id: envelope.message.data.id,
                    skuId: envelope.message.data.skuId,
                    path: envelope.message.data.path,
                    qty: parseFloat(envelope.message.data.qty).toFixed(2),
                    extraAttributes: envelope.message.data.extraAttributes,
                    bundleItems: envelope.message.data.bundleItems,
                    recipeItems: envelope.message.data.recipeItems,
                    comboItems: envelope.message.data.comboItems,
                    isDefaultRecipeQuantitiesIncluded: true
                }
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAdd, Vendd.Cart, function (envelope) {
		var data = {
			items: envelope.message.data
		};

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.MultipleAddSuccess(response));
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/MultipleAddToCart',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, Vendd.Cart, function (envelope) {
		if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
		} else { 
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
		}
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

		    if (response.success) {
		        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ProductRemoved(envelope.message.data.id));
		        if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
		    } else
		        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/RemoveFromCart',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantity, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success && response.code === 'OperationSuccesful') {

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));

				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else if (response.success && response.code === 'ValidationError') {
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetCartItemQty',
			data: {
				item: {
					id: envelope.message.data.id,
					qty: envelope.message.data.qty
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantities, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));

				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		var options = {
			url: 'EcomService.svc/SetCartItemsQty',
			data: {
				items: envelope.message.data.items
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.UpdateBundleItems, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));

				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/UpdateBundleItems',
			data: {
				item: {
					id: envelope.message.data.id,
					bundleItems: envelope.message.data.bundleItems
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyExtraAllowanceOrCharge, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetAllowanceOrCharge',
			data: {
				item: {
					itemId: envelope.message.data.itemId,
					shopAllowanceorChargeId: envelope.message.data.shopAllowanceorChargeId,
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.DisableExtraAllowanceOrCharge, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/RemoveAllowanceOrCharge',
			data: {
				item: {
					itemId: envelope.message.data.itemId,
					shopAllowanceorChargeId: envelope.message.data.shopAllowanceorChargeId,
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftwrap, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetCartItemGiftWrap',
			data: {
				item: {
					id: envelope.message.data.id,
					wrapId: envelope.message.data.wrapId,
					message: envelope.message.data.message
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftwraps, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		var options = {
			url: 'EcomService.svc/SetCartItemsGiftWrap',
			data: {
				items: envelope.message.data.items
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftCard, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GiftCardApplyFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GiftCardApplyFailed(response));
		}

		var options = {
			url: 'EcomService.svc/SetGiftCard',
			data: {
				code: envelope.message.data.code,
				amount: envelope.message.data.amount
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});


	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddGiftCartEmailAddress, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
			    if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddGiftCartEmailAddressSuccess());
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/AddGiftCartEmailAddress',
			data: {
				items: envelope.message.data.items,
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearAllGiftCards, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearAllGiftCards',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearGiftCard, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearGiftCard',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Clear, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCart',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

    /*Coupons*/
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyCoupon, Vendd.Cart, function (envelope) {
	    function onSuccess(response) {
	        Vendd.Cart.ClearClientModel();
	        if (response.success) {
	            if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	        };
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	    }

	    var options = {
	        url: 'EcomService.svc/SetCoupon',
	        data: {
	            code: envelope.message.data.code
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearCoupon, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			if (response.success) {
				Vendd.Cart.ClearClientModel();
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCoupon',
			data: {
				code: envelope.message.data.code
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearCoupons, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCoupons',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
    });


	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyExternalCoupon, Vendd.Cart, function (envelope) {
	    function onSuccess(response) {
	        Vendd.Cart.ClearClientModel();
	        if (response.success) {
	            if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	        };
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	    }

	    var options = {
	        url: 'api/ExternalCoupon/SetExternalCouponCode',
	        data: {
	            code: envelope.message.data.code
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearExternalCoupon, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.Cart.ClearClientModel();
                if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
        }

        var options = {
            url: 'api/ExternalCoupon/RemoveExternalCouponCode',
            data: {
                code: envelope.message.data.code
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearExternalCoupons, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            Vendd.Cart.ClearClientModel();
            if (response.success) {
                if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
        }

        var options = {
            url: 'api/ExternalCoupon/ClearExternalCoupons',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	/*GiftCards*/

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearGiftCard, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearGiftCard',
			data: {
				code: envelope.message.data.code
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, Vendd.Cart, function (envelope) {
		if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
		} else { 
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
		}
		
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, Vendd.Cart, function (envelope) {
		if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
		} else { 
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
		}
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingData, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataSuccess(response));
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataFailed(response));
		}

		var options = {
			url: 'CartService.svc/ApplyShippingData',
			data: {
				countryCode: envelope.message.data.countryCode,
				postCode: envelope.message.data.postCode,
				areaId: envelope.message.data.areaId,
				shippingMethodId: envelope.message.data.shippingMethodId,
				shippingCompanyId: envelope.message.data.shippingCompanyId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModel, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetShippingModelSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetShippingModelFailed(response));
		}

		var options = {
			url: 'CartService.svc/GetShippingViewModel',
			data: {
				countryCode: envelope.message.data.countryCode,
				postCode: envelope.message.data.postCode,
				areaId: envelope.message.data.areaId,
				shippingMethodId: envelope.message.data.shippingMethodId,
				shippingCompanyId: envelope.message.data.shippingCompanyId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddOrderItemsToCart, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartSuccess(response));
				if (venddProjectConfigs.CartSimpleModelEnabled && LhApp.Context.Item.Template !== 'shoppingCart') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetCartCountModel());
				} else { 
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartFailed(response));
		}

		var options = {
			url: 'EcomService.svc/AddOrderItemsToCart',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.Cart.GetNewGiftCardEmail = function (cartItem, literals, wrapper) {
		var newGiftCardEmail = {
			FromName: '',
			ToName: '',
			Email: '',
			CustomText: '',
			Title: cartItem.Title,
			ProductId: cartItem.ProductId,
			VariantId: cartItem.VariantId,
			CartProductId: cartItem.Id
		};

		var literals = { Literals: literals };
		$.extend(newGiftCardEmail, literals);
		var observable = new Vendd.Observable(newGiftCardEmail);
		observable.valEngine = Vendd.Cart.CreateGiftCardEmailValidationModel(observable);

		return observable;
	};

	Vendd.Cart.CreateGiftCardEmailValidationModel = function (observable) {

		var defaultValidationModel = ({
			FromName: [{ rule: "required" }],
			ToName: [{ rule: "required" }],
			Email: [{ rule: "required" }, { rule: "isEmail" }]
		});

		var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

		var propertyChanging = function propertyChanging(data, propertyName, value) {

			var valOptions = {
				ValidationEngine: valEngine,
				PropertyName: propertyName,
				PropertyValue: value
			};
			Vendd.DataValidation.Validate(valOptions);
		};

		observable.AddListenerToPropertyChanging('FromName', propertyChanging);
		observable.AddListenerToPropertyChanging('ToName', propertyChanging);
		observable.AddListenerToPropertyChanging('Email', propertyChanging);
		return valEngine;
	};

	Vendd.Cart.ClearClientModel = function () {
		localStorage.removeItem('CurrentCartModel');
	};

	Vendd.Cart.GetClientModel = function () {
	    var mdl = JSON.parse(localStorage.getItem("CurrentCartModel"));

	    return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
	};

	Vendd.Cart.SetClientModel = function (mdl) {
	    localStorage.setItem('CurrentCartModel', JSON.stringify(mdl));
	};

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetDeliveryPoint, Vendd.Cart, function (envelope) {
        function onSuccess(success) {
            if (success)
                window.location.reload();
        }

        function onFailure(response) {
        }

        var options = {
            url: 'ProductListService.svc/SetDeliveryPoint',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetCartCountModel, Vendd.Cart, function (envelope) {

		if (pending === true) {
			return false;
		};

        if (pendingSessionStatus) {
            pending = true;
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionState());
            return false;
        }

		function onSuccess(response) {
			model = model || {};
            model.Cart = response.data;
            model.LangCode = LhApp.Context.Language;

			if (venddProjectConfigs.CartAvailabilityRestrictionMessages) {
				try {
					if (Vendd.Cart.PendingMessages) model.Cart.PendingMessages = $.merge([], Vendd.Cart.PendingMessages);
				} catch (ex) {
					model.Cart.PendingMessages = null;
				}
				Vendd.Cart.PendingMessages = null;
			}
			
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));
			
            Vendd.Cart.SetClientModel(model);
			pending = false;
		}

		function onFailure(response) {

			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			pending = false;
		}

		var itemId = 0, templateCode = "";
		if (LhApp.Context.Item !== undefined) {
			itemId = LhApp.Context.Item.Id;
		}

		if (LhApp.Context.Item) {
		    templateCode = LhApp.Context.Item.Template;
		}

		var options = {
		    data: { currentItemId: itemId, templateCode: templateCode },
		    url: 'api/Cart/GetCartCountModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (model != null && model != undefined && Vendd.Cart.GetClientModel() != null && document.cookie.indexOf('ForceClearCartLocalStorage') == -1) {

			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));
			return true;
		}

		pending = true;
        Cookies.remove('ForceClearCartLocalStorage', { path: '/' });

		pending = true;
		Vendd.Service.call(options);

		return true;
    });


	var model = Vendd.Cart.GetClientModel();

	return Vendd;

})(Vendd || {});